import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    this.autoDismissAll()
  }

  messageTargetConnected(element) {
    this.autoDismiss(element)
  }

  dismiss(event) {
    const toast = event.target.closest(".toast-message")
    this.fadeOut(toast)
  }

  autoDismissAll() {
    this.messageTargets.forEach(toast => this.autoDismiss(toast))
  }

  autoDismiss(element) {
    if (element.classList.contains("toast-alert")) return
    setTimeout(() => this.fadeOut(element), 4000)
  }

  fadeOut(element) {
    if (!element || !element.isConnected) return
    element.classList.add("toast-fade-out")
    setTimeout(() => element.remove(), 400)
  }
}
